import CreationForm from '../../../components/knowledges/KnowledgeForm/KnowledgeForm';
import Page from '../../../components/shared/Page/Page';

const NewKnowledge = () => {
  return (
    <Page withBackground hideMainMenu>
      <CreationForm />
    </Page>
  );
};

export default NewKnowledge;
